import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_GLOBAL_APP_URL,
});

export { client };
